export const HOMEOWNER = 3;
